import { ExamCenterProctorRequestStep } from '@exam-center/graphql';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { useGetReviewerPermissions } from './use-get-reviewer-permissions';

export function useGetReviewerPermissionByStep(currentStep: ExamCenterProctorRequestStep) {
  const { view, update } = useGetReviewerPermissions();

  // ------ View Access ------
  const hasFirstTierReviewerViewAccess =
    currentStep === ExamCenterProctorRequestStep.InReview_1 && view.firstTierReviewer;
  const hasSecondTierReviewerViewAccess =
    currentStep === ExamCenterProctorRequestStep.InReview_2 && view.secondTierReviewer;

  const hasAtLeastOneViewPermission = useHasPermission(
    [
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.VIEW,
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.VIEW,
    ],
    'OR',
  );
  const isOnRejectedStep = currentStep === ExamCenterProctorRequestStep.Rejected;
  const hasViewAccessOnRejectedStep = hasAtLeastOneViewPermission && isOnRejectedStep;

  const hasViewAccess =
    hasFirstTierReviewerViewAccess ||
    hasSecondTierReviewerViewAccess ||
    view.supervisor ||
    hasViewAccessOnRejectedStep; // Allow view access for all roles if the request is rejected

  // ------ Update Access ------
  const hasFirstTierReviewerUpdateAccess =
    currentStep === ExamCenterProctorRequestStep.InReview_1 && update.firstTierReviewer;
  const hasSecondTierReviewerUpdateAccess =
    currentStep === ExamCenterProctorRequestStep.InReview_2 && update.secondTierReviewer;

  const hasUpdateAccess =
    hasFirstTierReviewerUpdateAccess || hasSecondTierReviewerUpdateAccess || update.supervisor;

  return {
    hasViewAccess,
    hasUpdateAccess,
  };
}
